export const FETCH_LOGIN_STATUS = 'FETCH_LOGIN_STATUS'
export const SET_USER_DATA = 'SET_USER_DATA'
export const FETCH_USER_DATA_STATUS = 'FETCH_USER_DATA_STATUS'
export const TOKEN_CHECKED = 'TOKEN_CHECKED'
export const FETCH_FORGOT_PASSWORD_STATUS = 'FETCH_FORGOT_PASSWORD_STATUS'
export const FETCH_RESTORE_PASSWORD_STATUS = 'FETCH_RESTORE_PASSWORD_STATUS'
